const emailMasking = (email: string) => {
    if (!!email && email.split("@").length > 1) {
        if (email.split("@")[0].length === 1) {
            return `${email.substr(0, 1)}${"*".repeat(email.split("@")[0].substr(3, email.split("@")[0].length - 1).length)}@${
                email.split("@")[1].split(".")[0].length >= 3
                    ? `${email.split("@")[1] && email.split("@")[1].split(".")[0].substr(0, 1)}${
                          email.split("@")[1] &&
                          "*".repeat(
                              email
                                  .split("@")[1]
                                  .split(".")[0]
                                  .substr(1, email.split("@")[1].split(".")[0].length - 1).length - 1
                          )
                      }${
                          email.split("@")[1] &&
                          email
                              .split("@")[1]
                              .split(".")[0]
                              .substr(email.split("@")[1].split(".")[0].length - 1)
                      }`
                    : `${email.split("@")[1].split(".")[0]}`
            }.${email.split("@")[1] && email.split("@")[1].split(".")[1]}`;
        } else if (email.split("@")[0].length === 2) {
            return `${email.substr(0, 2)}${"*".repeat(email.split("@")[0].substr(3, email.split("@")[0].length - 1).length)}@${
                email.split("@")[1].split(".")[0].length >= 3
                    ? `${email.split("@")[1] && email.split("@")[1].split(".")[0].substr(0, 1)}${
                          email.split("@")[1] &&
                          "*".repeat(
                              email
                                  .split("@")[1]
                                  .split(".")[0]
                                  .substr(1, email.split("@")[1].split(".")[0].length - 1).length - 1
                          )
                      }${
                          email.split("@")[1] &&
                          email
                              .split("@")[1]
                              .split(".")[0]
                              .substr(email.split("@")[1].split(".")[0].length - 1)
                      }`
                    : `${email.split("@")[1].split(".")[0]}`
            }.${email.split("@")[1] && email.split("@")[1].split(".")[1]}`;
        } else {
            return `${email.substr(0, 3)}${"*".repeat(email.split("@")[0].substr(3, email.split("@")[0].length - 1).length)}@${
                email.split("@")[1].split(".")[0].length >= 3
                    ? `${email.split("@")[1] && email.split("@")[1].split(".")[0].substr(0, 1)}${
                          email.split("@")[1] &&
                          "*".repeat(
                              email
                                  .split("@")[1]
                                  .split(".")[0]
                                  .substr(1, email.split("@")[1].split(".")[0].length - 1).length - 1
                          )
                      }${
                          email.split("@")[1] &&
                          email
                              .split("@")[1]
                              .split(".")[0]
                              .substr(email.split("@")[1].split(".")[0].length - 1)
                      }`
                    : `${email.split("@")[1].split(".")[0]}`
            }.${email.split("@")[1] && email.split("@")[1].split(".")[1]}`;
        }
    }
};

export { emailMasking };
